module.exports = __webpack_public_path__ + "static/img/withdraw.7dc20d94.png";